var _path, _path2, _path3, _path4, _path5, _g, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFoundLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1741 19.8892C14.1741 31.8892 22.9241 46.7292 33.7341 52.9692C39.3741 56.2292 44.4641 56.4892 48.0341 54.2892L52.8641 51.4992L51.6741 49.5692C48.4241 51.2992 43.9541 50.9492 39.0041 48.0892C29.1041 42.3492 21.0841 28.7692 21.0841 17.7392C21.0841 12.6492 22.7941 8.98916 25.6141 7.08916L24.4141 5.13916L19.5841 7.88916C16.2341 9.88916 14.1741 14.0092 14.1741 19.8892Z",
    fill: "url(#paint0_linear_1352_358832)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.794 66.8091C68.794 66.8091 68.904 67.6691 66.904 69.0491C64.904 70.4291 64.174 70.2291 64.174 70.2291L50.054 51.1091L54.674 47.6891L68.794 66.8091Z",
    fill: "url(#paint1_linear_1352_358832)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.164 47.9392C29.264 42.2292 21.234 28.6492 21.234 17.6192C21.234 13.8292 22.184 10.8392 23.834 8.76917C18.964 9.52917 15.744 13.7692 15.744 20.7692C15.744 31.7692 23.744 45.3792 33.674 51.0892C40.174 54.8392 45.864 54.2792 49.004 50.3292C46.184 50.7692 42.794 50.0192 39.164 47.9192",
    fill: "url(#paint2_linear_1352_358832)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M49.0006 51.2893C55.9598 47.2714 55.9601 34.2434 49.0013 22.1905C42.0425 10.1375 30.7598 3.62376 23.8006 7.64163C16.8415 11.6595 16.8412 24.6875 23.8 36.7405C30.7587 48.7934 42.0415 55.3072 49.0006 51.2893Z",
    fill: "url(#paint3_linear_1352_358832)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.584 76.8891L55.744 69.4791C56.844 68.3291 56.844 67.1191 54.974 66.0391H54.924L27.654 50.2891L27.564 50.2291C24.974 48.7391 21.744 49.1791 19.144 50.6791C16.544 52.1791 15.574 54.1591 18.144 55.6791L45.574 71.4691C46.4107 71.9152 47.3273 72.1917 48.2712 72.2827C49.215 72.3736 50.1675 72.2773 51.074 71.9991L64.074 79.5091C65.304 80.2291 69.834 77.6191 68.584 76.8891Z",
    fill: "url(#paint4_linear_1352_358832)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M44.364 52.6792C41.5082 52.5713 38.73 51.7199 36.304 50.2092C26.424 44.5092 18.384 30.5792 18.384 19.2092C18.384 13.6392 20.274 9.47916 23.704 7.48916C27.134 5.49916 31.684 5.88916 36.484 8.69916C46.394 14.4092 54.484 28.3392 54.484 39.7492C54.484 45.3192 52.594 49.4792 49.164 51.4592C47.7035 52.2918 46.0448 52.7133 44.364 52.6792ZM28.484 6.64916C26.8939 6.63123 25.3274 7.03492 23.944 7.81916C20.644 9.71916 18.824 13.7492 18.824 19.1692C18.824 30.4492 26.824 44.1692 36.544 49.8492C41.234 52.5592 45.634 53.0092 48.934 51.0992C52.234 49.1892 54.054 45.1592 54.054 39.7492C54.054 28.4692 46.104 14.7492 36.334 9.05916C33.9716 7.58661 31.2658 6.75591 28.484 6.64916Z",
    fill: "url(#paint5_linear_1352_358832)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.484 39.3892C58.484 27.3892 49.734 12.5392 38.924 6.30915C33.304 3.04915 28.214 2.77915 24.644 4.97915L19.814 7.75915L21.004 9.69915C24.254 7.95915 28.724 8.31915 33.674 11.1692C43.574 16.8892 51.594 30.4592 51.594 41.4892C51.594 46.3492 50.044 49.8892 47.484 51.8892C47.364 51.9892 46.314 52.6192 46.174 52.7092L48.294 54.1292L53.124 51.3392C56.484 49.3292 58.484 45.2292 58.484 39.3892Z",
    fill: "url(#paint6_linear_1352_358832)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1352_358832",
    x1: 4.08407,
    y1: -10.9208,
    x2: 44.9641,
    y2: 59.8892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1352_358832",
    x1: 50.054,
    y1: 58.9591,
    x2: 68.794,
    y2: 58.9591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1352_358832",
    x1: 16.584,
    y1: 12.2492,
    x2: 42.994,
    y2: 57.9792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1352_358832",
    x1: 36.3958,
    y1: -44.666,
    x2: 36.3958,
    y2: 99.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#787878",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#818181",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C8C8C",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1352_358832",
    x1: 27.884,
    y1: 73.5591,
    x2: 57.024,
    y2: 56.7391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#565656",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171717",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1352_358832",
    x1: 26.044,
    y1: 11.4992,
    x2: 51.844,
    y2: 56.1892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "white",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1352_358832",
    x1: 17.344,
    y1: -18.6108,
    x2: 58.234,
    y2: 52.2092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundLarge);
export default __webpack_public_path__ + "static/media/not_found_large.b510b5dc0a800cdc84b63d13996099b9.svg";
export { ForwardRef as ReactComponent };